import React from 'react';

export interface ThemeProviderProps {
    theme?: 'light' | 'dark';
    children?: React.JSX.Element;
}

const ThemeContext = React.createContext<ThemeProviderProps['theme']>(undefined);
ThemeContext.displayName = 'ThemeContext';

export const ThemeProvider: React.FC<ThemeProviderProps> = (props) => {
    const { theme, children } = props;

    const themeToUse = React.useMemo(() => {
        let resolvedTheme = theme ?? 'light';

        if (!theme) {
            window.matchMedia('(prefers-color-scheme: dark)').matches
                ? (resolvedTheme = 'dark')
                : (resolvedTheme = 'light');
        }
        return resolvedTheme;
    }, [theme]);

    return (
        <ThemeContext.Provider value={themeToUse}>
            <div data-mode={themeToUse}>{children}</div>
        </ThemeContext.Provider>
    );
};

ThemeProvider.displayName = 'ThemeProvider';

export const useThemeProvider = (): ThemeProviderProps['theme'] => {
    return React.useContext(ThemeContext);
};
